
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexBUquJ6FW9selPoMmXmiQ06xberjjtjDDexnQK6NGwH0Meta } from "/opt/buildhome/repo/app/pages/index.vue?macro=true";
import { default as historyUqLAsrwXcV12FlsNR_3VG5WZEUPWybsS4lPb0qcYr28Meta } from "/opt/buildhome/repo/app/pages/history.vue?macro=true";
import { default as profile3T6twBBB1Ka3DY1WJby9IkZzkfgB7Q2zDlTSBnPLUy4Meta } from "/opt/buildhome/repo/app/pages/profile.vue?macro=true";
import { default as sign_45inMZ70W2od9H8zgUuLOWPYs8ng9Ckq7raqAdM3ApZc8yIMeta } from "/opt/buildhome/repo/app/pages/sign-in.vue?macro=true";
import { default as sign_45uphOwoLnEDeap3yWIFCavy_45vbStZVDQ1amU1OYq_jmsTsMeta } from "/opt/buildhome/repo/app/pages/sign-up.vue?macro=true";
import { default as _91_46_46_46slug_93_0ZERmeKg__97aWWO2qTLlEheqCXjmWFXVaDkyvUojIMeta } from "/opt/buildhome/repo/app/pages/[...slug].vue?macro=true";
import { default as indext9oTNizHaT0tIQuIn7quqv33BbTZe7NKz3FMDru_NMUMeta } from "/opt/buildhome/repo/app/pages/admin/index.vue?macro=true";
import { default as mediaQoTrevDUPuZAjq6do1PCG_js_benRR_45Vk_45EMaingEjYMeta } from "/opt/buildhome/repo/app/pages/admin/media.vue?macro=true";
import { default as usersPxIjee9FRRS_LdeThM9OIv_45b_xlsSLs2_fB_45A_45dDW9EMeta } from "/opt/buildhome/repo/app/pages/admin/users.vue?macro=true";
import { default as _91id_93rpT4697ov8GZ__45D_Y_Ot29_45XmAGUPRS5DVfViDH2gfgMeta } from "/opt/buildhome/repo/app/pages/preview/[id].vue?macro=true";
import { default as cardsi_ghNAILbNtHQDLFEVPWHWAkTO9U63Cn6MhF_zizZR4Meta } from "/opt/buildhome/repo/app/pages/admin/archive/cards.vue?macro=true";
import { default as indexZVrisFKld0M7kbHnbsAyhqABN0xmbF07ssUdHyti4PUMeta } from "/opt/buildhome/repo/app/pages/admin/archive/index.vue?macro=true";
import { default as eventshysTMf1rP77KoWfUlH9UgTR6IF_45M4uRPeGAxlutmy24Meta } from "/opt/buildhome/repo/app/pages/admin/archive/events.vue?macro=true";
import { default as memorya9tcAOKL9xAwCosf_45mZxlgVKHJbM0c3JKDZ_45ypSSOlsMeta } from "/opt/buildhome/repo/app/pages/admin/archive/memory.vue?macro=true";
import { default as series9KuWnhk4kAQaT3_a_bNhmtM0Qa_w80_5UwynJ9cGC9kMeta } from "/opt/buildhome/repo/app/pages/admin/archive/series.vue?macro=true";
import { default as card_45setjkH8__457PLXFNIE5fMHZPAfG_459K9Tt_MN0H78WgmiFWUMeta } from "/opt/buildhome/repo/app/pages/admin/archive/card-set.vue?macro=true";
import { default as cards_45v2ZwlxrKrej0ByKp4gMxjo4uQtFKS93_8QbnWaChvNPXsMeta } from "/opt/buildhome/repo/app/pages/admin/archive/cards-v2.vue?macro=true";
import { default as index09flNB4sQaCJBFA_45EDONKBsA_45X5Z6n3uGlo0D2xBps0Meta } from "/opt/buildhome/repo/app/pages/admin/publishing/index.vue?macro=true";
import { default as footer5TeSGKCqnzxtu3IUiRhseoI42STcIEN6h5o_hU2OVWcMeta } from "/opt/buildhome/repo/app/pages/admin/publishing/footer.vue?macro=true";
import { default as momentsrCRRzFbKoxZTvzb4LvTaGwfAXGLcTvmQVMPWgGaIi34Meta } from "/opt/buildhome/repo/app/pages/admin/publishing/moments.vue?macro=true";
import { default as conventions7kSR86qNvEJutrg0wLV9Cmqb0KcXdjRCWI8psS_458jJ8Meta } from "/opt/buildhome/repo/app/pages/admin/archive/conventions.vue?macro=true";
import { default as _91key_93QrBV6wTCMwB7wq_2QsJ6Sso5Hqynwu_457ba4ZeQXluuYMeta } from "/opt/buildhome/repo/app/pages/admin/archive/looks/[key].vue?macro=true";
import { default as submissionsYDEXG8fu5OzlvpSO2Zfn1QWG1GbQlNBK1pMrX72ZvxYMeta } from "/opt/buildhome/repo/app/pages/admin/archive/submissions.vue?macro=true";
import { default as _91year_93UirxHMdhTKHSWpFXuAq3i5CCSOWVxiSX_r2rDDszwyoMeta } from "/opt/buildhome/repo/app/pages/admin/archive/year/[year].vue?macro=true";
import { default as sectionsJ64q3P2sZrC7aKeHY2tT1PJ_efxsz3wZXUOGjO9biKgMeta } from "/opt/buildhome/repo/app/pages/admin/publishing/sections.vue?macro=true";
import { default as _91id_93sCEKcmKWxduGkz9IDz6lPwwNurpZcOMgYOHjtirx5tIMeta } from "/opt/buildhome/repo/app/pages/admin/publishing/pages/[id].vue?macro=true";
import { default as index3LZRFOPmbtvaUSjW5x6TdTHbDJXVM6qUelz2U3EUsMIMeta } from "/opt/buildhome/repo/app/pages/admin/publishing/pages/index.vue?macro=true";
import { default as component_45stub7hu1B1hmgThGmBiLwDIQK3V4zmzIGtvGvIUbFf76OCMMeta } from "/opt/buildhome/repo/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub7hu1B1hmgThGmBiLwDIQK3V4zmzIGtvGvIUbFf76OCM } from "/opt/buildhome/repo/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/opt/buildhome/repo/app/pages/index.vue")
  },
  {
    name: "history",
    path: "/history",
    meta: historyUqLAsrwXcV12FlsNR_3VG5WZEUPWybsS4lPb0qcYr28Meta || {},
    component: () => import("/opt/buildhome/repo/app/pages/history.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: profile3T6twBBB1Ka3DY1WJby9IkZzkfgB7Q2zDlTSBnPLUy4Meta || {},
    component: () => import("/opt/buildhome/repo/app/pages/profile.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    component: () => import("/opt/buildhome/repo/app/pages/sign-in.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    component: () => import("/opt/buildhome/repo/app/pages/sign-up.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/opt/buildhome/repo/app/pages/[...slug].vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: indext9oTNizHaT0tIQuIn7quqv33BbTZe7NKz3FMDru_NMUMeta || {},
    component: () => import("/opt/buildhome/repo/app/pages/admin/index.vue")
  },
  {
    name: "admin-media",
    path: "/admin/media",
    meta: mediaQoTrevDUPuZAjq6do1PCG_js_benRR_45Vk_45EMaingEjYMeta || {},
    component: () => import("/opt/buildhome/repo/app/pages/admin/media.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    meta: usersPxIjee9FRRS_LdeThM9OIv_45b_xlsSLs2_fB_45A_45dDW9EMeta || {},
    component: () => import("/opt/buildhome/repo/app/pages/admin/users.vue")
  },
  {
    name: "preview-id",
    path: "/preview/:id()",
    component: () => import("/opt/buildhome/repo/app/pages/preview/[id].vue")
  },
  {
    name: "admin-archive-cards",
    path: "/admin/archive/cards",
    meta: cardsi_ghNAILbNtHQDLFEVPWHWAkTO9U63Cn6MhF_zizZR4Meta || {},
    component: () => import("/opt/buildhome/repo/app/pages/admin/archive/cards.vue")
  },
  {
    name: "admin-archive",
    path: "/admin/archive",
    meta: indexZVrisFKld0M7kbHnbsAyhqABN0xmbF07ssUdHyti4PUMeta || {},
    component: () => import("/opt/buildhome/repo/app/pages/admin/archive/index.vue")
  },
  {
    name: "admin-archive-events",
    path: "/admin/archive/events",
    meta: eventshysTMf1rP77KoWfUlH9UgTR6IF_45M4uRPeGAxlutmy24Meta || {},
    component: () => import("/opt/buildhome/repo/app/pages/admin/archive/events.vue")
  },
  {
    name: "admin-archive-memory",
    path: "/admin/archive/memory",
    meta: memorya9tcAOKL9xAwCosf_45mZxlgVKHJbM0c3JKDZ_45ypSSOlsMeta || {},
    component: () => import("/opt/buildhome/repo/app/pages/admin/archive/memory.vue")
  },
  {
    name: "admin-archive-series",
    path: "/admin/archive/series",
    meta: series9KuWnhk4kAQaT3_a_bNhmtM0Qa_w80_5UwynJ9cGC9kMeta || {},
    component: () => import("/opt/buildhome/repo/app/pages/admin/archive/series.vue")
  },
  {
    name: "admin-archive-card-set",
    path: "/admin/archive/card-set",
    meta: card_45setjkH8__457PLXFNIE5fMHZPAfG_459K9Tt_MN0H78WgmiFWUMeta || {},
    component: () => import("/opt/buildhome/repo/app/pages/admin/archive/card-set.vue")
  },
  {
    name: "admin-archive-cards-v2",
    path: "/admin/archive/cards-v2",
    meta: cards_45v2ZwlxrKrej0ByKp4gMxjo4uQtFKS93_8QbnWaChvNPXsMeta || {},
    component: () => import("/opt/buildhome/repo/app/pages/admin/archive/cards-v2.vue")
  },
  {
    name: "admin-publishing",
    path: "/admin/publishing",
    meta: index09flNB4sQaCJBFA_45EDONKBsA_45X5Z6n3uGlo0D2xBps0Meta || {},
    component: () => import("/opt/buildhome/repo/app/pages/admin/publishing/index.vue")
  },
  {
    name: "admin-publishing-footer",
    path: "/admin/publishing/footer",
    meta: footer5TeSGKCqnzxtu3IUiRhseoI42STcIEN6h5o_hU2OVWcMeta || {},
    component: () => import("/opt/buildhome/repo/app/pages/admin/publishing/footer.vue")
  },
  {
    name: "admin-publishing-moments",
    path: "/admin/publishing/moments",
    meta: momentsrCRRzFbKoxZTvzb4LvTaGwfAXGLcTvmQVMPWgGaIi34Meta || {},
    component: () => import("/opt/buildhome/repo/app/pages/admin/publishing/moments.vue")
  },
  {
    name: "admin-archive-conventions",
    path: "/admin/archive/conventions",
    meta: conventions7kSR86qNvEJutrg0wLV9Cmqb0KcXdjRCWI8psS_458jJ8Meta || {},
    component: () => import("/opt/buildhome/repo/app/pages/admin/archive/conventions.vue")
  },
  {
    name: "admin-archive-looks-key",
    path: "/admin/archive/looks/:key()",
    meta: _91key_93QrBV6wTCMwB7wq_2QsJ6Sso5Hqynwu_457ba4ZeQXluuYMeta || {},
    component: () => import("/opt/buildhome/repo/app/pages/admin/archive/looks/[key].vue")
  },
  {
    name: "admin-archive-submissions",
    path: "/admin/archive/submissions",
    meta: submissionsYDEXG8fu5OzlvpSO2Zfn1QWG1GbQlNBK1pMrX72ZvxYMeta || {},
    component: () => import("/opt/buildhome/repo/app/pages/admin/archive/submissions.vue")
  },
  {
    name: "admin-archive-year-year",
    path: "/admin/archive/year/:year()",
    meta: _91year_93UirxHMdhTKHSWpFXuAq3i5CCSOWVxiSX_r2rDDszwyoMeta || {},
    component: () => import("/opt/buildhome/repo/app/pages/admin/archive/year/[year].vue")
  },
  {
    name: "admin-publishing-sections",
    path: "/admin/publishing/sections",
    meta: sectionsJ64q3P2sZrC7aKeHY2tT1PJ_efxsz3wZXUOGjO9biKgMeta || {},
    component: () => import("/opt/buildhome/repo/app/pages/admin/publishing/sections.vue")
  },
  {
    name: "admin-publishing-pages-id",
    path: "/admin/publishing/pages/:id()",
    meta: _91id_93sCEKcmKWxduGkz9IDz6lPwwNurpZcOMgYOHjtirx5tIMeta || {},
    component: () => import("/opt/buildhome/repo/app/pages/admin/publishing/pages/[id].vue")
  },
  {
    name: "admin-publishing-pages",
    path: "/admin/publishing/pages",
    meta: index3LZRFOPmbtvaUSjW5x6TdTHbDJXVM6qUelz2U3EUsMIMeta || {},
    component: () => import("/opt/buildhome/repo/app/pages/admin/publishing/pages/index.vue")
  },
  {
    name: component_45stub7hu1B1hmgThGmBiLwDIQK3V4zmzIGtvGvIUbFf76OCMMeta?.name,
    path: "/admin/publishing/timeline",
    component: component_45stub7hu1B1hmgThGmBiLwDIQK3V4zmzIGtvGvIUbFf76OCM
  }
]